export enum AddPhoneErrorType {
  Unspecified,
  RedirectPhoneRequired,
}
